<template>
  <v-card flat class="grey lighten-4 rounded-t-xl">
    <v-card-title>
      {{ $t('cart.remove') }} <span class="font-italic mx-1">{{ itemTitle }}</span> {{ $t('cart.fromCart') }}
      <v-spacer />
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-card-title>
    <v-card-actions>
      <v-container class="pt-0">
        <v-row>
          <v-col>
            <v-btn
              :id="`${itemTitle}-remove-from-cart-confirm`"
              rounded
              large
              block
              depressed
              dark
              color="error"
              height="44"
              class="text-none"
              @click="confirm"
            >
                {{ $t('buttons.confirm') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "RemoveFromCartConfirm",
  props: {
    itemTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
